// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BaseUI from 'base-ui';
import cookies from 'vue-cookies';
import Vue2TouchEvents from 'vue2-touch-events';
import App from './App.vue';
import Segment from './Segment';
import DDLogs from './DDLogs';
import DDRum from './DDRum';
import Intercom from './Intercom';
import Sentry from './Sentry';
import PaymeInterface from './Payme';
import router from './router';
import store from './store';
import config from './config';
import interceptors from './api/interceptors';
import validator from './rules/validators';

import './style';

config.fetch().then(() => {
  Vue.config.productionTip = false;
  Vue.use(Segment);
  Vue.use(Vue2TouchEvents);
  Vue.use(Intercom);
  Vue.use(cookies);
  Vue.use(BaseUI);
  DDLogs.init();
  DDRum.init();
  Sentry.init();
  PaymeInterface.initOrGet();
  interceptors.init();
  validator.init();
  const link = document.querySelector("link[rel*='icon']");
  link.href = config.get().favicon;

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
  });
});
